import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import RootReducer from './../reducers'

const middlewares = [thunk]
let store

if (process.env.REACT_APP_NODE_ENV === 'DEV') {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    store = createStore(RootReducer, composeEnhancers(applyMiddleware(...middlewares)))
} else
    store = createStore(RootReducer, applyMiddleware(...middlewares))

export default store